import { useState } from "react";
import { Box } from "@mui/material";
import NavBar from "../Utilities/NavBar";
import FilterTab from "../Utilities/FilterTab";
import SearchIcon from "@mui/icons-material/Search";
import BasicTextField from "components/v2/common/BasicTextField";
import MessageListItem from "./Utilities/MessageListItem";
import useGetInboxMessages from "./Utilities/hooks/useGetInboxMessages";
import MessageListLoader from "./Utilities/MessageListLoader";
import InboxPagination from "./Utilities/InboxPagination";

export default function InboxV3() {
  const {
    loading,
    messages,
    totalCount,
    handlePageChange,
    handleDateChange,
    handleChannelGroupsChange,
    handleStatusChange,
    handleSentimentsChange,
    handleSearch,
    searchTerm,
    channelGroups,
    selectedChannelGroups,
    inboxStatus,
    selectedSentiments,
    page,
    startDate,
    endDate,
    statusCounts,
  } = useGetInboxMessages();

  const [searchInput, setSearchInput] = useState(searchTerm);
  return (
    <Box sx={{ backgroundColor: "#EDEDE4" }}>
      <NavBar />
      <Box sx={styles.root}>
        <Box sx={styles.container}>
          <Box sx={styles.bodyWrapper}>
            <FilterTab
              startDate={startDate}
              endDate={endDate}
              onDateChange={handleDateChange}
              channelGroups={channelGroups}
              selectedChannelGroups={selectedChannelGroups}
              onChannelsChange={handleChannelGroupsChange}
              selectedStatus={inboxStatus}
              onStatusChange={handleStatusChange}
              selectedSentiments={selectedSentiments}
              onSentimentsChange={handleSentimentsChange}
              statusCounts={statusCounts}
            />

            <Box sx={{ flex: "1" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box component={"h1"} sx={styles.headingText}>
                  Inbox
                </Box>

                <Box
                  component={"p"}
                  sx={{
                    color: "#6b746b",
                    fontFamily: "FustatRegular",
                    fontSize: "14px",
                    m: 0,
                  }}
                >
                  {statusCounts?.["OPEN"] || 0} open • sorted by priority
                </Box>
              </Box>

              <Box my={2}>
                <BasicTextField
                  name={"searchMessage"}
                  value={searchInput}
                  handleChange={(event) => setSearchInput(event.target.value)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      handleSearch(searchInput);
                    }
                  }}
                  startIcon={<SearchIcon sx={styles.icon} />}
                  placeholder={"Search messages, order numbers..."}
                  sx={styles.textField}
                />
              </Box>

              <Box
                sx={{
                  overflow: "hidden",
                  backgroundColor: "#ffffff",
                  borderRadius: "14px",
                }}
              >
                {loading && <MessageListLoader />}

                {!loading && messages?.items?.length > 0 && (
                  <>
                    {messages?.items?.map((item) => (
                      <MessageListItem key={item.messageId} data={item} />
                    ))}
                  </>
                )}

                <InboxPagination
                  handlePageChange={handlePageChange}
                  totalCount={totalCount}
                  page={page}
                  loading={loading}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

const styles = {
  root: {
    pt: 4,
    minHeight: "100vh",
    pb: 10,
  },
  container: {
    px: { xs: 2, sm: 4, md: 6 },
    width: "100%",
    maxWidth: "1440px",
    position: "relative",
    mx: "auto",
  },
  bodyWrapper: {
    display: "flex",
    gap: 4,
    alignItems: "flex-start",
    position: "relative",
  },
  headingText: {
    m: 0,
    fontFamily: "FustatBold",
    fontSize: 30,
    lineHeight: 1.2,
    letterSpacing: "-0.02em",
    color: "#0C2728",
  },
  icon: {
    color: "#495D5E",
  },
  textField: {
    height: "44px",
    borderRadius: "12px",
    backgroundColor: "#ffffff",
    [`& fieldset`]: {
      borderRadius: "12px",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#D0D9D9",
      },
      "&:hover fieldset": {
        borderColor: "#9EA9A9",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#003300",
      },
    },
  },
};
